import { Popover } from 'lib/components/Popover';
import { ColumnButton } from 'lib/components/ColumnButton';
import { capitalize } from 'lodash';
import ColorSwatchPanel from '../ColorSwatchPanel';

type ColorButtonProps = {
  description: string;
  icon: JSX.Element;
  value: string;
  onChange: (newValue: string) => void;
};

function ColorButton({ description, icon, value, onChange }: ColorButtonProps) {
  const buttonText = `${capitalize(description)} color`;
  return (
    <Popover
      id={`${description}-color-popover`}
      activator={
        <ColumnButton
          size="sm"
          type="button"
          buttonText={buttonText}
          startIcon={icon}
        />
      }
      popoverType="menu"
    >
      <ColorSwatchPanel
        id={description}
        value={value}
        onChange={newValue =>
          onChange(newValue === 'White' ? 'transparent' : newValue)
        }
      />
      <style>
        {`
        #${description}-color-popover-toggle path:last-child {
          fill: ${value};
          fill-opacity: 1;
        }

        #${description}-color-popover-toggle .MuiSvgIcon-root {
          width: 20px;
          height: 20px;
        }
        `}
      </style>
    </Popover>
  );
}

export default ColorButton;
